import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailNoteListComponent } from '@app-components/email/email-note-list/email-note-list.component';
import { EmailAuditComponent } from '../email-audit/email-audit.component';
import { EmailTemplatesComponent } from '@app-components/email/email-templates/email-templates.component';
import { EmailMenuContent } from '@app-types/enums/emails';
import { EmailNotificationsDialogComponent } from '../email-notifications-dialog/email-notifications-dialog.component';
import { EmailContract } from '@app-types/api/email';
import { ChangedTags } from '@app-types/api/tag';
import { EmailAddTagsDialogComponent } from '@app-components/email/email-add-tags-dialog/email-add-tags-dialog.component';
import { SidePanelShellComponent } from '@app-components/common/side-panel-shell/side-panel-shell.component';

@Component({
  selector: 'app-email-sidenav',
  imports: [
    EmailNoteListComponent,
    EmailAuditComponent,
    EmailTemplatesComponent,
    EmailNotificationsDialogComponent,
    EmailAddTagsDialogComponent,
    SidePanelShellComponent,
  ],
  templateUrl: './email-sidenav.component.html',
  styleUrls: ['./email-sidenav.component.scss'],
})
export class EmailSidenavComponent {
  @Input() useMobileView: boolean;
  @Input() public emailId?: number;
  @Input() public mailAccountId: number;
  @Input() public menuIsOpened = false;
  @Input() public menuContent: EmailMenuContent | null;
  @Input() public emailDetails: EmailContract;
  @Output() public refreshNotes = new EventEmitter();
  @Output() public templateSelected = new EventEmitter();
  @Output() public createTag = new EventEmitter<ChangedTags>();
  @Output() public closeMenu = new EventEmitter();
  @Output() public openEmailDetails = new EventEmitter();
  public menuContentTypes = EmailMenuContent;

  constructor() {}

  public get menuHeader(): string {
    switch (this.menuContent) {
      case this.menuContentTypes.Notifications:
        return 'notifications';
      case this.menuContentTypes.Notes:
        return 'notes';
      case this.menuContentTypes.Templates:
        return 'templates';
      case this.menuContentTypes.Audit:
        return 'audit';
      case this.menuContentTypes.Tags:
        return 'addTags';
      default:
        return '';
    }
  }
}
